(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["canine-patient-story"] && !Shopify.designMode) return;
  try {
    const initialisePatientStoryVideos = (root = document) => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    root.querySelectorAll('.cc-patient-story__video').forEach((video) => {
      if (video.dataset.patientStoryReady === 'true') return;
      video.dataset.patientStoryReady = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;

      const playVideo = () => {
        if (reducedMotion.matches) {
          video.pause();
          return;
        }
        const playback = video.play();
        if (playback) playback.catch(() => {});
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            playVideo();
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.15 });

      observer.observe(video);
      video.addEventListener('canplay', playVideo, { once: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialisePatientStoryVideos(), { once: true });
  } else {
    initialisePatientStoryVideos();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialisePatientStoryVideos(event.target);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["canine-truffle-feature"] && !Shopify.designMode) return;
  try {
    (() => {
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const initialise = () => {
      document.querySelectorAll('.cc-truffle__video').forEach((video) => {
        if (video.dataset.autoplayReady) return;
        video.dataset.autoplayReady = 'true';
        if (motion.matches) return;
        const start = () => {
          if (motion.matches || !video.paused) return;
          video.muted = true;
          video.playsInline = true;
          video.play().catch(() => {});
        };
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
              observer.disconnect();
              start();
            }
          }, { threshold: 0.2 });
          observer.observe(video);
        } else {
          start();
        }
      });
    };
    motion.addEventListener('change', () => {
      if (motion.matches) document.querySelectorAll('.cc-truffle__video').forEach((video) => video.pause());
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise);
    else initialise();
    document.addEventListener('shopify:section:load', initialise);
  })();
  } catch(e) { console.error(e); }
})();

})();
